import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { DynamicDialogProvider } from '../../billing-tool/context/dynamic-dialog.context';
import {
  ACCOUNTING_BILLED_VOID_CLAIMS_CATEGORY,
  BULK_ADJUSTMENTS_CATEGORY,
  CsvUploader,
} from '../../csv-uploader';

export const ACCOUNTING_CSV_UPLOAD_TEST_ID = 'accounting-csv-upload-section';

export const ACCOUNTING_UPLOAD_CATEGORIES = [
  ACCOUNTING_BILLED_VOID_CLAIMS_CATEGORY,
  BULK_ADJUSTMENTS_CATEGORY,
];

const AccountingCsvUpload = (): JSX.Element => (
  <DynamicDialogProvider>
    <HHStack
      direction="column"
      spacing={4}
      padding={4}
      data-testid={ACCOUNTING_CSV_UPLOAD_TEST_ID}
    >
      <HHTypography hhVariant="section-title">CSV Upload</HHTypography>
      <CsvUploader allowedCategories={ACCOUNTING_UPLOAD_CATEGORIES} />
    </HHStack>
  </DynamicDialogProvider>
);

export default AccountingCsvUpload;
